import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatDividerModule, MatIconModule, MatTabsModule } from '@angular/material';

import { FuseSharedModule } from '@fuse/shared.module';

import { ProfileService } from 'app/main/content/pages/profile/profile.service';
import { ProfileComponent } from 'app/main/content/pages/profile/profile.component';
import { ProfileTimelineComponent } from 'app/main/content/pages/profile/tabs/timeline/timeline.component';
import { ProfileAboutComponent } from 'app/main/content/pages/profile/tabs/about/about.component';
import { ProfilePhotosVideosComponent } from 'app/main/content/pages/profile/tabs/photos-videos/photos-videos.component';


const routes = [
    {
        path     : 'profile',
        component: ProfileComponent,
        resolve  : {
            profile: ProfileService
        }
    }
];

@NgModule({
    declarations: [
        ProfileComponent,
        ProfileTimelineComponent,
        ProfileAboutComponent,
        ProfilePhotosVideosComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatTabsModule,

        FuseSharedModule
    ],
    providers   : [
        ProfileService
    ]
})
export class ProfileModule
{
}
